
import * as antlr from "antlr4ng";
import { Token } from "antlr4ng";


export class RuleGrammarLexer extends antlr.Lexer {
    public static readonly COMPARE_OP = 1;
    public static readonly PLUS = 2;
    public static readonly MINUS = 3;
    public static readonly STAR = 4;
    public static readonly SLASH = 5;
    public static readonly LPAREN = 6;
    public static readonly RPAREN = 7;
    public static readonly TAG = 8;
    public static readonly NUMBER = 9;
    public static readonly WS = 10;
    public static readonly INVALID = 11;

    public static readonly channelNames = [
        "DEFAULT_TOKEN_CHANNEL", "HIDDEN"
    ];

    public static readonly literalNames = [
        null, null, "'+'", "'-'", "'*'", "'/'", "'('", "')'"
    ];

    public static readonly symbolicNames = [
        null, "COMPARE_OP", "PLUS", "MINUS", "STAR", "SLASH", "LPAREN", 
        "RPAREN", "TAG", "NUMBER", "WS", "INVALID"
    ];

    public static readonly modeNames = [
        "DEFAULT_MODE",
    ];

    public static readonly ruleNames = [
        "COMPARE_OP", "PLUS", "MINUS", "STAR", "SLASH", "LPAREN", "RPAREN", 
        "TAG", "NUMBER", "WS", "INVALID", "DIGIT",
    ];


    public constructor(input: antlr.CharStream) {
        super(input);
        this.interpreter = new antlr.LexerATNSimulator(this, RuleGrammarLexer._ATN, RuleGrammarLexer.decisionsToDFA, new antlr.PredictionContextCache());
    }

    public get grammarFileName(): string { return "RuleGrammar.g4"; }

    public get literalNames(): (string | null)[] { return RuleGrammarLexer.literalNames; }
    public get symbolicNames(): (string | null)[] { return RuleGrammarLexer.symbolicNames; }
    public get ruleNames(): string[] { return RuleGrammarLexer.ruleNames; }

    public get serializedATN(): number[] { return RuleGrammarLexer._serializedATN; }

    public get channelNames(): string[] { return RuleGrammarLexer.channelNames; }

    public get modeNames(): string[] { return RuleGrammarLexer.modeNames; }

    public static readonly _serializedATN: number[] = [
        4,0,11,84,6,-1,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,4,7,4,2,5,7,5,2,
        6,7,6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,2,11,7,11,1,0,1,0,1,0,1,
        0,1,0,1,0,1,0,3,0,33,8,0,1,1,1,1,1,2,1,2,1,3,1,3,1,4,1,4,1,5,1,5,
        1,6,1,6,1,7,1,7,1,7,1,7,1,7,1,7,5,7,53,8,7,10,7,12,7,56,9,7,1,7,
        1,7,1,7,1,8,4,8,62,8,8,11,8,12,8,63,1,8,1,8,4,8,68,8,8,11,8,12,8,
        69,3,8,72,8,8,1,9,4,9,75,8,9,11,9,12,9,76,1,9,1,9,1,10,1,10,1,11,
        1,11,0,0,12,1,1,3,2,5,3,7,4,9,5,11,6,13,7,15,8,17,9,19,10,21,11,
        23,0,1,0,5,2,0,60,62,8800,8800,1,0,125,125,2,0,44,44,46,46,3,0,9,
        10,13,13,32,32,1,0,48,57,91,0,1,1,0,0,0,0,3,1,0,0,0,0,5,1,0,0,0,
        0,7,1,0,0,0,0,9,1,0,0,0,0,11,1,0,0,0,0,13,1,0,0,0,0,15,1,0,0,0,0,
        17,1,0,0,0,0,19,1,0,0,0,0,21,1,0,0,0,1,32,1,0,0,0,3,34,1,0,0,0,5,
        36,1,0,0,0,7,38,1,0,0,0,9,40,1,0,0,0,11,42,1,0,0,0,13,44,1,0,0,0,
        15,46,1,0,0,0,17,61,1,0,0,0,19,74,1,0,0,0,21,80,1,0,0,0,23,82,1,
        0,0,0,25,26,5,33,0,0,26,33,5,61,0,0,27,28,5,60,0,0,28,33,5,61,0,
        0,29,30,5,62,0,0,30,33,5,61,0,0,31,33,7,0,0,0,32,25,1,0,0,0,32,27,
        1,0,0,0,32,29,1,0,0,0,32,31,1,0,0,0,33,2,1,0,0,0,34,35,5,43,0,0,
        35,4,1,0,0,0,36,37,5,45,0,0,37,6,1,0,0,0,38,39,5,42,0,0,39,8,1,0,
        0,0,40,41,5,47,0,0,41,10,1,0,0,0,42,43,5,40,0,0,43,12,1,0,0,0,44,
        45,5,41,0,0,45,14,1,0,0,0,46,47,5,123,0,0,47,48,5,123,0,0,48,54,
        1,0,0,0,49,53,8,1,0,0,50,51,5,125,0,0,51,53,8,1,0,0,52,49,1,0,0,
        0,52,50,1,0,0,0,53,56,1,0,0,0,54,52,1,0,0,0,54,55,1,0,0,0,55,57,
        1,0,0,0,56,54,1,0,0,0,57,58,5,125,0,0,58,59,5,125,0,0,59,16,1,0,
        0,0,60,62,3,23,11,0,61,60,1,0,0,0,62,63,1,0,0,0,63,61,1,0,0,0,63,
        64,1,0,0,0,64,71,1,0,0,0,65,67,7,2,0,0,66,68,3,23,11,0,67,66,1,0,
        0,0,68,69,1,0,0,0,69,67,1,0,0,0,69,70,1,0,0,0,70,72,1,0,0,0,71,65,
        1,0,0,0,71,72,1,0,0,0,72,18,1,0,0,0,73,75,7,3,0,0,74,73,1,0,0,0,
        75,76,1,0,0,0,76,74,1,0,0,0,76,77,1,0,0,0,77,78,1,0,0,0,78,79,6,
        9,0,0,79,20,1,0,0,0,80,81,9,0,0,0,81,22,1,0,0,0,82,83,7,4,0,0,83,
        24,1,0,0,0,8,0,32,52,54,63,69,71,76,1,6,0,0
    ];

    private static __ATN: antlr.ATN;
    public static get _ATN(): antlr.ATN {
        if (!RuleGrammarLexer.__ATN) {
            RuleGrammarLexer.__ATN = new antlr.ATNDeserializer().deserialize(RuleGrammarLexer._serializedATN);
        }

        return RuleGrammarLexer.__ATN;
    }


    private static readonly vocabulary = new antlr.Vocabulary(RuleGrammarLexer.literalNames, RuleGrammarLexer.symbolicNames, []);

    public override get vocabulary(): antlr.Vocabulary {
        return RuleGrammarLexer.vocabulary;
    }

    private static readonly decisionsToDFA = RuleGrammarLexer._ATN.decisionToState.map( (ds: antlr.DecisionState, index: number) => new antlr.DFA(ds, index) );
}